import { useContent } from "@/lib/content";
import { getOpenStatus, getActiveHours, getTodayHoliday } from "@/lib/hours";

export const OpenStatus = ({ dark = false }) => {
  const c = useContent();
  const holiday = getTodayHoliday(c.holidays);
  let s;
  if (holiday) {
    s = holiday.closed
      ? { open: false, label: `Heute geschlossen${holiday.label ? ` · ${holiday.label}` : ""}` }
      : getOpenStatus([{ day: ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"][new Date().getDay()], time: holiday.time, closed: false }]);
  } else {
    s = getOpenStatus(getActiveHours(c).hours);
  }
  const color = s.open ? (s.soon ? "bg-amber-400" : "bg-green-500") : "bg-red-400";
  return (
    <span data-testid="open-status" className={`inline-flex items-center gap-2 text-[11px] tracking-[0.12em] uppercase ${dark ? "text-cream/80" : "text-ink-soft"}`}>
      <span className="relative flex h-2 w-2">
        {s.open && <span className={`absolute inline-flex h-full w-full rounded-full ${color} opacity-60 animate-ping`} />}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${color}`} />
      </span>
      {s.label}
    </span>
  );
};
